var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g-dialog',{attrs:{"closable":false}},[_c('p',{staticClass:"errors"}),_vm._l((_vm.errors),function(ref,i){
var a = ref[0];
var e = ref[1];
return _c('div',{key:i,staticClass:"erorr"},[_vm._v(_vm._s(_vm.$t(a))+_vm._s(_vm.$t(e)))])}),_c('p'),_c('div',{staticClass:"end-h"},[_c('button',{on:{"click":_vm.close}},[_vm._v(_vm._s(_vm.$t('ok')))])])],2)}
var staticRenderFns = []

export { render, staticRenderFns }